import {ApiError, ApiService} from "@/services/api.service";
import {Constants} from "@/constants";

class SMS {
    constructor(sms) {
        this.phoneNumber = sms ? sms.phoneNumber : undefined
        this.message = sms ? sms.message : undefined
    }
}


const NotificationService = {
    sendSMS: async function(sms) {
        try {
            let endpoint = Constants.ENDPOINT_NOTIFICATIONS + "/sms"
            const response = await ApiService.post(endpoint, sms)
            return response
        }catch(error) {
            throw new ApiError(error)
        }
    }


}

export {NotificationService, SMS}